export default class Experiments {

  constructor(imktStorageUtils) {
    const CUSTOM_EXPERIMENTS_ITEM_KEY = "custom.experiment.opts";
    let storageUtils = imktStorageUtils;

    return {

      experimentKey: undefined,
      experimentAttribute: undefined,
      simplifiedAdminPassword: undefined,
      bypassEmailCheck: undefined,
      blockRedirect: undefined,

      init: function() {
        // nothing at the moment
      },

      insertExperimentProperties: function (data) {

        if (this.experimentKey) {
          Object.assign(data, {experimentKey: this.experimentKey});
        }

        if (this.experimentAttribute) {
          Object.assign(data, {experimentAttribute: this.experimentAttribute});
        }

        if (this.simplifiedAdminPassword) {
          Object.assign(data.onDemandAccountDetails, {adminPassword: this.simplifiedAdminPassword});
        }
      },

      getExperimentsNotificationOpts: function(accountName, productKeys) {
        var opts = {
          onDemandAccountName: accountName,
          onDemandProductKeys: productKeys,
          customExperimentOpts: this.getExperimentDataStored()
        };

        return opts;
      },

      getExperimentDataStored: function() {
        let data = storageUtils.getLocalStorage(CUSTOM_EXPERIMENTS_ITEM_KEY);

        if (data) {
          return JSON.parse(data);
        }
        return null;
      },

      clearExperimentDataStored: function() {
        storageUtils.removeLocalStorage(CUSTOM_EXPERIMENTS_ITEM_KEY);
      },

      enableEmailCheckBypass: function() {
        // PUR-8609: for users not logged in, bypass check email route
        this.bypassEmailCheck = true;
      },

      enableSimplifiedAdminPassword: function() {
        // PUR-6032: generate random password to prefill form for validation purposes
        this.simplifiedAdminPassword = Math.random().toString(36);
      },

      enableBlockRedirect: function() {
          this.blockRedirect = true;
      },

      setExperimentKey: function (key) {
          this.experimentKey = key;
      },

      setExperimentAttribute: function (attr) {
          this.experimentAttribute = attr;
      }

    };
  }
}
